const SearchLoader = window.SearchLoader = {
  show(element = '.js-more') {
    $(element).prepend('<div class="search-loader"></div>');
  },

  hide() {
    $('.search-loader').remove();
  }
}